const style = {
  textWrapperPad: { bottom: 'small' },
  textMargin: { bottom: 'xsmall' },
  inputTextWrapperPad: { bottom: 'small' },
  checkBoxWrapperPad: { bottom: 'small' },
  captchaWrapperPad: { vertical: 'small' },
  buttonWrapperPad: { vertical: 'small', horizontal: 'small' },
  form: {
    formField: {
      label: {
        color: 'dark-2',
        size: 'small',
        margin: { vertical: '0', bottom: 'small', horizontal: '0' },
      },
      border: 0,
    },
  },
}

export default style
